export default __webpack_public_path__ + "static/media/a4.541c9c06.webp";